module.exports = __webpack_public_path__ + "assets/img/G2.85231276.png";